import { dao } from '@platform/dao';
import type { IModuleDefinition } from '@platform/core/types';
import type { IModuleKeysArg } from './args/IModuleKeysArg';
import { baseApi, run } from './baseApi';
import { mapLimited } from './mapLimited';

/** Скільки визначень модулів запитувати одночасно. */
const PARALLEL = 4;

/** Аргумент: ключі з простором або (сумісність) лише рядок ключів — тоді опубліковані визначення. */
const argOf = (arg: IModuleKeysArg | string): IModuleKeysArg => (typeof arg === 'string' ? { keys: arg } : arg);

/**
 * Визначення кількох модулів одним запитом стану (GET /meta/modules/{key}?workspaceId=, не більше 4 одночасно): «Налаштування» рахують
 * поля й форми всіх модулів простору — злиті з налаштуваннями простору (ADR-023). Кеш — година; зміна модулів простору (тег Catalog)
 * перечитує все, а збереження налаштувань одного типу запису оновлює кеш на місці (overrideApi), без перечитування всіх модулів.
 */
export const metadataBulkApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    getModuleDefinitions: b.query<IModuleDefinition[], IModuleKeysArg | string>({
      queryFn: (arg) => {
        const { keys, workspaceId } = argOf(arg);
        return run(() => mapLimited(keys.split(',').filter(Boolean), PARALLEL, (k) => dao.metadata.module(k, workspaceId)));
      },
      providesTags: ['Catalog'],
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useGetModuleDefinitionsQuery } = metadataBulkApi;
